import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { isFlow } from '../utils/isFlow';
import { isIntegration } from '../utils/isIntegration';
import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getHasRefreshedNewPortalAuth, getIsNewPortalCreated } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { getCurrentStep, isEndOfFlow } from '../store/flow/selectors';
import { getIsWordPressAuthFinished } from '../store/integrations/selectors';
import { hasAnsweredAllPostExistingAccountSelectedQuestions } from '../store/signup-data/selectors';
export const canInstallFallbackTimer = state => {
  const portalIdDefined = isPortalIdDefined(state);
  const isNewPortalCreated = getIsNewPortalCreated(state);
  const currentStep = getCurrentStep(state);
  const hasRefreshedNewPortalAuth = getHasRefreshedNewPortalAuth(state);
  const endOfFlow = isEndOfFlow(state);
  const isWPAuthFinished = getIsWordPressAuthFinished(state);

  if (isIntegration(Integration.Wordpress) && !isWPAuthFinished) {
    return false;
  }

  if (isExistingUserExistingAccount(state) && !isFlow(Flow.StandaloneCmsPartner)) {
    return endOfFlow && portalIdDefined && hasAnsweredAllPostExistingAccountSelectedQuestions(state);
  }

  return endOfFlow && hasRefreshedNewPortalAuth && !currentStep && isNewPortalCreated && portalIdDefined;
};